export const CUSTOMER_STRINGS = {
    ADD_CUSTOMER: "Add Customer",
    EDIT_CUSTOMER: "Edit Customer",
    FIRST_NAME: "First Name",
    LAST_NAME: "Last Name",
    EMAIL: "Email",
    PHONE_NUMBER: "Phone Number",
    SEARCH_CUSTOMERS: "Search Customers",
    EMAIL_CUSTOMER: "Email Customer",
    TEXT_CUSTOMER: "Text Customer",
    CAMPAIGN: "Campaign",
};

export const CUSTOMER_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "id", isSortable: false, label: "Customer ID" },
    { id: "name", isSortable: true, label: "Customer Name" },
    { id: "email", isSortable: true, label: "Email" },
    { id: "phone", isSortable: false, label: "Phone Number" },
    { id: "campaign", isSortable: false, label: "Campaign" },
];

export const CUSTOMER_TABLE_COLUMN_KEYS = {
    ACTIONS: "actions",
    CUSTOMER_ID: "id",
    CUSTOMER_NAME: "name",
    EMAIL: "emailaddress",
    CAMPAIGN: "campaign",
    PHONE: "phone"
};

export const CUSTOMER_KEYS = {
    NAME: "name",
    FIRST_NAME: "firstname",
    LAST_NAME: "lastname",
    EMAIL: "emailaddress",
    PHONE_NUMBER: "customeruniqueid",
    CAMPAIGN_ID: "campaignid",
    CAMPAIGN: "campaign",
};

export const CUSTOMER_MESSAGES = {
    NO_CUSTOMERS: "No customers to display",
    CUSTOMER_ADDED: "Customer added successfully!",
    CUSTOMER_UPDATED: "Customer updated successfully!",
    CUSTOMER_EMAIL: "Email sent successfully!",
    CUSTOMER_TEXT: "Text sent successfully!",
    NO_CAMPAIGNS: "No campaigns available",
};

export const CUSTOMER_ERRORS = {
    ADD_CUSTOMER_ERROR: "Error adding customer:",
    SAVE_CUSTOMER_ERROR: "Error saving customer:",
    UPDATE_CUSTOMER_ERROR: "Error updating customer:",
    FETCH_CUSTOMERS_ERROR: "Error fetching customers:",
    EMAIL_CUSTOMERS_ERROR: "Error sending email:",
    TEXT_CUSTOMERS_ERROR: "Error sending email:",
};

export const CUSTOMER_COMPLIANCE_TEXT = {
    No_COMPLIANCE: "No compliance records found for this conversation.",
    COMPLAINCE_DETAILS: "Compliance Details",
    GROUP: "Group",
    RULE_ID: "Rule ID",
    DESCRIPTION: "Description",
    COMPLIANT: "Compliant",
    COMMENTS: "Comments"
};